/**
 * Indicates which payment method was used in the transaction.
 * @enum
 * @name PaymentMethods
 * @kind enum
 * @exports
 */
export enum PaymentMethods {
  CASH = "Cash",
  CARD = "Card",
  POS = "POS",
  USSD = "USSD",
  QR_CODE = "QR Code",
  IN_BANK_TRANSFER = "Pay with Transfer",
  PAYMENT_LINK = "Payment Link",
}
